'use strict';

/* General Libs */
import 'expose-loader?tv4!tv4';
import 'angular-messages/angular-messages.min';
import 'angular-schema-form';
import 'angular-schema-form-bootstrap';
import '../../components/angular-schema-form-file-upload/schema-form-file';

/* Views */
import EFormList from './list/e-form-list.component';
import EFormEditor from './edit/e-form-editor.component';
import EForm from './form/e-form.component';
import EFormBrowser from './browser/e-form-browser.component';

import EFormModal from '../../components/eform-modal/eform-modal.component';

/* Services */
import EFormsService from '../../components/eforms/eforms.service';
import EFormResultsService from '../../components/eform-results/eform-results.service';

export default angular.module('conduuApp.eForms', ['schemaForm', 'ngMessages', 'ngSchemaFormFile',
  EFormList, EForm, EFormBrowser, EFormEditor, EFormResultsService, EFormsService, EFormModal])
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/index.js